import {GIPages} from './hotels-types';

const mirror = <V extends keyof any>(v: V) => v;

export const navigationMenuNames = {
  overview: mirror('Overview'),
  guestReviews: mirror('Guest Reviews'),
  foodDining: mirror('Food & Dining'),
  amenities: mirror('Amenities'),
  location: mirror('Location'),
  hotelPolicies: mirror('Property Policies'),
  goSafe: mirror('goSafe'),
  safetyHygiene: mirror('Safety & Hygiene'),
  rooms: mirror('Room Options'),
  stays: mirror('Stay Options'),
  aboutProperty: mirror('About Property'),
  similarHotels: mirror('Similar Properties'),
  faqs: mirror('FAQs'),
  reviews: mirror('Reviews'),
  hostedBy: mirror('Host'),
  /**
   * @TODO
   * srp screen names should live in separate file
   */
  locationFilters: mirror('locationFilters'),
  hourlyFilterScreen: mirror('hourlyFilterScreen'),
  dayUsePoliciesRules: mirror('Policies & Rules'),
  filters: mirror('filters'),
  maps: mirror('maps'),
};

export enum NavigationIdsMweb {
  overview = 'overview',
  detailAmenitiesInfo = 'detailAmenitiesInfo',
  pageListing = 'page-listing',
  foodAndDining = 'food-and-dining',
  aboutProperty = 'aboutProperty',
  reviews = 'reviews',
  filters = 'filters',
  maps = 'maps',
  location = 'location',
  locationFilters = 'locationFilters',
  hourlyFilterScreen = 'hourlyFilterScreen',
  detailsPolicy = 'details-policy',
  fndGallery = 'food-and-dining-gallery',
  detailsGallery = 'details-gallery',
  rnrGallery = 'rnrgallery',
  dayUseRnrGallery = 'hourly-rnr-gallery',
}

export const routeMapper = {
  [GIPages.Details]: {
    header: GIPages.Details,
    menuName: navigationMenuNames.overview,
  },
  [NavigationIdsMweb.aboutProperty]: {
    header: GIPages.DetailsAboutUs,
    menuName: navigationMenuNames.aboutProperty,
  },
  [NavigationIdsMweb.detailAmenitiesInfo]: {
    header: GIPages.DetailsAmenties,
    menuName: navigationMenuNames.amenities,
  },
  [NavigationIdsMweb.detailsGallery]: {
    header: GIPages.DetailsGallery,
    menuName: '',
  },
  [NavigationIdsMweb.detailsPolicy]: {
    header: GIPages.DetailsPolicy,
    menuName: navigationMenuNames.hotelPolicies,
  },
  [NavigationIdsMweb.fndGallery]: {
    header: GIPages.DetailsFndGallery,
    menuName: '',
  },
  [NavigationIdsMweb.foodAndDining]: {
    header: GIPages.DetailsFnd,
    menuName: navigationMenuNames.foodDining,
  },
  [NavigationIdsMweb.location]: {
    header: GIPages.DetailsLocation,
    menuName: navigationMenuNames.location,
  },
  [NavigationIdsMweb.rnrGallery]: {
    header: '',
    menuName: '',
  },
  [NavigationIdsMweb.reviews]: {
    header: GIPages.DetailsReviews,
    menuName: navigationMenuNames.guestReviews,
  },
};
